import { getBaseUrls } from './baseURLhelper'
// const BANNER_IMAGE_WIDTH = 2880
// const BANNER_IMAGE_HEIGHT = 2880
// const BANNER_IMAGE_TYPE = 'LANDING_PAGE_MULTISCREEN_1_1'

// const VOD_DETAILS_BCG_WIDTH = 1920
// const VOD_DETAILS_BCG_HEIGHT = 1080
// const VOD_DETAILS_BCG_TYPE = 'EVENT_16_9'

const channelImageWidth = 160
const channelImageHeight = 90
const channelImageType = 'LOGO_16_9'

// const eventDetailWidth = 896 // TODO 1200
// const eventDetailHeight = 504 // TODO 675
// const eventDetailType = 'EVENT_16_9'

const EVENT_THUMB_WIDTH = 1440
const EVENT_THUMB_HEIGHT = 810
const EVENT_THUMB_TYPE = 'EVENT_16_9'

// const NOW_TV_CARD_WIDTH = 640
// const NOW_TV_CARD_HEIGHT = 360
// const NOW_TV_CARD_TYPE = 'EVENT_16_9'

const RADIO_CARD_WIDTH = 480
const RADIO_CARD_HEIGHT = 270
const RADIO_CARD_TYPE = 'LOGO_16_9'
// TODO Missing card dimensions for APPs, because this is different from radio, although they are same
// const APP_CARD_WIDTH = 480
// const APP_CARD_HEIGHT = 270
// const APP_CARD_TYPE = 'APPLICATION'

// const ONDEMAND_CARD_WIDTH = 504
// const ONDEMAND_CARD_HEIGHT = 744
// const ONDEMAND_CARD_TYPE = 'VOD_POSTER_21_31'

// const VOD_BANNER_IMAGE_WIDTH = 1440
// const VOD_BANNER_IMAGE_HEIGHT = 720
// const VOD_BANNER_IMAGE_TYPE = 'VOD_POSTER_2_1'

const CATEGORY_IMAGE_WIDTH = 52
const CATEGORY_IMAGE_HEIGHT = 52
const CATEGORY_IMAGE_TYPE = 'CATEGORY_1_1'

// const CATALOGUE_IMAGE_WIDTH = 170
// const CATALOGUE_IMAGE_HEIGHT = 58
// const CATALOGUE_IMAGE_TYPE = 'APPLICATION'

// const VOD_POSTER_IMAGE_WIDTH = 210
// const VOD_POSTER_IMAGE_HEIGHT = 310
// const VOD_POSTER_IMAGE_TYPE = 'VOD_POSTER_21_31'

// const CH_VOD_LP_IMAGE_WIDTH = 1920
// const CH_VOD_LP_IMAGE_HEIGHT = 1080
// const CH_VOD_LP_IMAGE_TYPE = 'LANDING_PAGE_STB_16_9'

// export const getBannerImagePath = function (images = []) {
//   return getImagePath(images, BANNER_IMAGE_WIDTH, BANNER_IMAGE_HEIGHT, BANNER_IMAGE_TYPE)
// }

export const getChannelImagePath = function (images = []) {
  return getImagePath(images, channelImageWidth, channelImageHeight, channelImageType) // || require('assets/images/photos/logo_placeholder_160x90.png')
}

// export const getEventDetailImagePath = function (images = []) {
//   return getImagePath(images, eventDetailWidth, eventDetailHeight, eventDetailType) || require('assets/images/photos/tv_guide_placeholder_1200x675.png')
// }

// export const getNowTvCardImagePath = function (images = []) {
//   return getImagePath(images, NOW_TV_CARD_WIDTH, NOW_TV_CARD_HEIGHT, NOW_TV_CARD_TYPE) || require('assets/images/photos/event_placeholder_640x360.png')
// }

// export const getImageCardImagePath = function (images = []) {
//   return getImagePath(images, NOW_TV_CARD_WIDTH, NOW_TV_CARD_HEIGHT, NOW_TV_CARD_TYPE) || require('assets/images/photos/categories_&_catalogues_640x360.png')
// }

export const getRadioCardImagePath = function (images = []) {
  return getImagePath(images, RADIO_CARD_WIDTH, RADIO_CARD_HEIGHT, RADIO_CARD_TYPE) || require('assets/images/photos/radio_placeholder_640x360.png')
}

// export const getAppCardImagePath = function (images = []) {
//   return getImagePath(images, APP_CARD_WIDTH, APP_CARD_HEIGHT, APP_CARD_TYPE) || require('assets/images/photos/event_placeholder_640x360.png')
// }

export const getThumbnailImagePath = function (images = []) {
  return getImagePath(images, EVENT_THUMB_WIDTH, EVENT_THUMB_HEIGHT, EVENT_THUMB_TYPE) || require('assets/images/photos/tv_guide_placeholder_1200x675.png')
}

// export const getVodBcgImagePath = function (images = []) {
//   return getImagePath(images, VOD_DETAILS_BCG_WIDTH, VOD_DETAILS_BCG_HEIGHT, VOD_DETAILS_BCG_TYPE)
// }

// export const getOndemandImagePath = function (images = []) {
//   return getImagePath(images, ONDEMAND_CARD_WIDTH, ONDEMAND_CARD_HEIGHT, ONDEMAND_CARD_TYPE) || require('assets/images/photos/VoD_poster_placeholder_504x744.png')
// }

// export const getVodBannerImagePath = function (images = []) {
//   return getImagePath(images, VOD_BANNER_IMAGE_WIDTH, VOD_BANNER_IMAGE_HEIGHT, VOD_BANNER_IMAGE_TYPE) || require('assets/images/photos/vod_banner_placeholder_1440x720.png')
// }

// export const getVodPosterImagePath = function (images = []) {
//   return getImagePath(images, VOD_POSTER_IMAGE_WIDTH, VOD_POSTER_IMAGE_HEIGHT, VOD_POSTER_IMAGE_TYPE) || require('assets/images/photos/VoD_poster_placeholder_504x744.png')
// }

// export const getVodCatalogueCategoryImagePath = function (images, mode) {
//   return getModeImagePath(images, APP_CARD_WIDTH, APP_CARD_HEIGHT, APP_CARD_TYPE, mode)
// }

// export const getVodCatalogueImagePath = function (images, mode) {
//   return getModeImagePath(images, CATALOGUE_IMAGE_WIDTH, CATALOGUE_IMAGE_HEIGHT, CATALOGUE_IMAGE_TYPE, mode)
// }

// export const getChVodLpImagePath = function (images) {
//   return getImagePath(images, CH_VOD_LP_IMAGE_WIDTH, CH_VOD_LP_IMAGE_HEIGHT, CH_VOD_LP_IMAGE_TYPE)
// }

export const getCategoryImagePath = function (images = [], mode) {
  let modeImages = images
  if (mode) {
    modeImages = images.filter((image) => {
      return image.mode === mode
    })
  }
  return getImagePath(modeImages, CATEGORY_IMAGE_WIDTH, CATEGORY_IMAGE_HEIGHT, CATEGORY_IMAGE_TYPE)
}

// function getModeImagePath (images, width, height, type, mode) {
//   let modeImages = images
//   if (mode) {
//     modeImages = images.filter((image) => {
//       return image.mode === mode
//     })
//   }
//   // console.log(modeImages)
//   return getImagePath(modeImages, width, height, type)
// }

function getImagePath (images = [], width, height, type) {
  let len = images.length
  let selectedWidth = 0
  let selectedImg = ''
  for (let i = len; i--;) {
    let image = images[i]

    if (image.type === type) {
      if (image.width === width && image.height === height) {
        selectedImg = image
        break
      } else if (image.width > selectedWidth) {
        selectedWidth = image.width
        selectedImg = image
      }
    }
  }

  return selectedImg ? (getBaseUrls('baseImages') + selectedImg.path).replace(/'/g, "\\'") : ''
}



// WEBPACK FOOTER //
// ./src/helpers/images.js